module.exports = __webpack_public_path__ + "media/images/categories/R.programming copy-2801f440ce8a3cab655d8271897ad6cd.png";